import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadLeistungsArtListStatus: 'idle',
    loadLeistungsArtListError: undefined as any,
    loadLeistungsArtListLastArgs: undefined as any,
    loadLeistungsArtStatus: 'idle',
    loadLeistungsArtError: undefined as any,
    saveLeistungsArtStatus: 'idle',
    saveLeistungsArtError: undefined as any,
    deleteLeistungsArtStatus: 'idle',
    deleteLeistungsArtError: undefined as any,

    leistungsArtList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadLeistungsArtList = createAsyncThunk('leistungsArtSlice/loadLeistungsArtList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().leistungsArtSlice.loadLeistungsArtListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurislieistart/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadLeistungsArtListStatus } = getState().leistungsArtSlice
        return loadLeistungsArtListStatus !== 'pending'
    }
})

export const loadLeistungsArt = createAsyncThunk('leistungsArtSlice/loadLeistungsArt', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurislieistart/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadLeistungsArtStatus } = getState().leistungsArtSlice
        return loadLeistungsArtStatus !== 'pending'
    }
})

export const saveLeistungsArt = createAsyncThunk('leistungsArtSlice/saveLeistungsArt', async ({ leistungsArt }: any, { rejectWithValue }: any) => {
    let promises = []
    if (leistungsArt?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurislieistart/${ leistungsArt?.HDR_ID }/`,
            prepareData(leistungsArt),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurislieistart/`,
            prepareData(leistungsArt),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveLeistungsArtStatus } = getState().leistungsArtSlice
        return saveLeistungsArtStatus !== 'pending'
    }
})

export const deleteLeistungsArt = createAsyncThunk('leistungsArtSlice/deleteLeistungsArt', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurislieistart/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteLeistungsArtStatus } = getState().leistungsArtSlice
        return deleteLeistungsArtStatus !== 'pending'
    }
})

const LeistungsArtSlice = createSlice({
    name: 'leistungsArtSlice',
    initialState,
    reducers: {
        resetloadLeistungsArtListError: (state) => {
            state.loadLeistungsArtListError = undefined
        },
        resetloadLeistungsArt: (state) => {
            state.formItem = undefined
            state.loadLeistungsArtError = undefined
        },
        resetloadLeistungsArtError: (state) => {
            state.loadLeistungsArtError = undefined
        },
        resetsaveLeistungsArt: (state) => {
            state.formItem = undefined
            state.saveLeistungsArtError = undefined
        },
        resetsaveLeistungsArtError: (state) => {
            state.saveLeistungsArtError = undefined
        },
        resetdeleteLeistungsArtError: (state) => {
            state.deleteLeistungsArtError = undefined
        },
        removeFromLeistungsArtListById: (state, action) => {
            state.leistungsArtList = state.leistungsArtList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromLeistungsArtListByIds: (state, action) => {
            state.leistungsArtList = state.leistungsArtList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.leistungsArtList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadLeistungsArtListStatus = 'preloaded'
            state.loadLeistungsArtListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.leistungsArtList = []
            state.loadLeistungsArtListStatus = 'idle'
            state.loadLeistungsArtListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadLeistungsArtList.pending, (state) => {
            state.loadLeistungsArtListStatus = 'pending'
            state.loadLeistungsArtListError = undefined
        })
        builder.addCase(loadLeistungsArtList.fulfilled, (state, action) => {
            state.loadLeistungsArtListStatus = 'idle'

            if (!action.payload) { return }

            state.loadLeistungsArtListLastArgs = action.payload.args

            {
                state.leistungsArtList = action.payload.data

            }
        })
        builder.addCase(loadLeistungsArtList.rejected, (state, action) => {
            state.loadLeistungsArtListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadLeistungsArtListError = action.error.message
            } else {
                state.loadLeistungsArtListError = action.payload
            }
        })

        builder.addCase(loadLeistungsArt.pending, (state) => {
            state.loadLeistungsArtStatus = 'pending'
            state.loadLeistungsArtError = undefined
        })
        builder.addCase(loadLeistungsArt.fulfilled, (state, action) => {
            state.loadLeistungsArtStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.leistungsArtList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.leistungsArtList.push(newItem) }
                else { state.leistungsArtList[i] = { ...state.leistungsArtList[i], ...newItem } }
            }
        })
        builder.addCase(loadLeistungsArt.rejected, (state, action) => {
            state.loadLeistungsArtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadLeistungsArtError = action.error.message
            } else {
                state.loadLeistungsArtError = action.payload
            }
        })

        builder.addCase(saveLeistungsArt.pending, (state) => {
            state.saveLeistungsArtStatus = 'pending'
            state.saveLeistungsArtError = undefined
        })
        builder.addCase(saveLeistungsArt.fulfilled, (state, action) => {
            state.saveLeistungsArtStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.leistungsArtList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.leistungsArtList.push(newItem) }
                else { state.leistungsArtList[i] = { ...state.leistungsArtList[i], ...newItem } }
            }
        })
        builder.addCase(saveLeistungsArt.rejected, (state, action) => {
            state.saveLeistungsArtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveLeistungsArtError = action.error.message
            } else {
                state.saveLeistungsArtError = action.payload
            }
        })

        builder.addCase(deleteLeistungsArt.pending, (state) => {
            state.deleteLeistungsArtStatus = 'pending'
            state.deleteLeistungsArtError = undefined
        })
        builder.addCase(deleteLeistungsArt.fulfilled, (state, action) => {
            state.deleteLeistungsArtStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.leistungsArtList = state.leistungsArtList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.leistungsArtList = state.leistungsArtList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteLeistungsArt.rejected, (state, action) => {
            state.deleteLeistungsArtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteLeistungsArtError = action.error.message
            } else {
                state.deleteLeistungsArtError = action.payload
            }
        })

    }
})

export const {
    resetloadLeistungsArtListError,
    resetloadLeistungsArt,
    resetloadLeistungsArtError,
    resetsaveLeistungsArt,
    resetsaveLeistungsArtError,
    resetdeleteLeistungsArtError,
    removeFromLeistungsArtListById,
    removeFromLeistungsArtListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = LeistungsArtSlice.actions
export default LeistungsArtSlice.reducer
